import axios from "../../../../../../api/axios";
import { handleApiError } from "./utils";
import { INCIDENT_ENDPOINTS } from "./endpoints";

export const createIncidentReport = async (payload) => {
    try {
        const res = await axios.post(INCIDENT_ENDPOINTS.CREATE, payload);
        return res.data.data;
    } catch (error) {
        handleApiError(error, "Failed to create incident report");
    }
};

export const getIncidentReports = async (params = {}) => {
    try {
        const res = await axios.get(INCIDENT_ENDPOINTS.GET_ALL, { params });
        return res.data;
    } catch (error) {
        handleApiError(error, "Failed to fetch incident reports");
    }
};

export const getIncidentStatusCounts = async (params = {}) => {
    try {
        const res = await axios.get(INCIDENT_ENDPOINTS.GET_STATUS_COUNTS, { params });
        return res.data;
    } catch (error) {
        handleApiError(error, "Failed to fetch incident status counts");
    }
};

export const getIncidentReportById = async (id) => {
    try {
        const url = INCIDENT_ENDPOINTS.GET_BY_ID.replace(":id", id);
        const res = await axios.get(url);
        return res.data.data;
    } catch (error) {
        handleApiError(error, "Failed to fetch incident report");
    }
};

export const updateIncidentReport = async (id, payload) => {
    try {
        const url = INCIDENT_ENDPOINTS.UPDATE.replace(":id", id);
        const res = await axios.patch(url, payload);
        return res.data.data;
    } catch (error) {
        handleApiError(error, "Failed to update incident report");
    }
};

export const deleteIncidentReport = async (id) => {
    try {
        const url = INCIDENT_ENDPOINTS.DELETE.replace(":id", id);
        const res = await axios.delete(url);
        return res.data;
    } catch (error) {
        handleApiError(error, "Failed to delete incident report");
    }
};

export const requestIncidentUploadUrl = async (id, fileName, contentType) => {
    try {
        const url = INCIDENT_ENDPOINTS.UPLOAD_REQUEST.replace(":id", id);
        const res = await axios.post(url, { fileName, contentType });
        return res.data.data;
    } catch (error) {
        handleApiError(error, "Failed to get upload URL");
    }
};

export const confirmIncidentUpload = async (id, key, docType, personIndex = 0) => {
    try {
        const url = INCIDENT_ENDPOINTS.CONFIRM_UPLOAD.replace(":id", id);
        const res = await axios.post(url, { key, docType, personIndex });
        return res.data?.data;
    } catch (error) {
        handleApiError(error, "Failed to confirm upload");
    }
};

export const getIncidentSignedUrls = async (keys) => {
    if (!keys?.length) return {};
    try {
        const res = await axios.post(INCIDENT_ENDPOINTS.SIGNED_URLS, { keys });
        return res.data.data;
    } catch (error) {
        handleApiError(error, "Failed to get signed URLs");
        return {};
    }
};

export const downloadIncidentPDF = async (id, timezone) => {
    try {
        let url = INCIDENT_ENDPOINTS.PDF.replace(":id", id);
        if (timezone) {
            url += `?timezone=${encodeURIComponent(timezone)}`;
        }
        const res = await axios.get(url, { responseType: "blob" });

        const blob = new Blob([res.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `incident_${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        handleApiError(error, "Failed to download PDF");
    }
};

export const sendIncidentNotification = async (id, templateType = "updated", additionalEmails = []) => {
    try {
        const url = INCIDENT_ENDPOINTS.SEND_NOTIFICATION.replace(":id", id);
        const res = await axios.post(url, {
            templateType,
            additionalNotificationEmails: additionalEmails,
        });
        return res.data;
    } catch (error) {
        handleApiError(error, `Failed to send ${templateType} notification`);
        throw error;
    }
};

export const updateIncidentStatus = async (id, data = {}) => {
    try {
        if (!data.status && data.comments === undefined) {
            throw new Error("At least status or comments must be provided");
        }
        const url = `/v2/incident-reports/${id}/status`;
        const res = await axios.patch(url, data);
        return res.data.data;
    } catch (error) {
        handleApiError(error, "Failed to update incident status/comments");
        throw error;
    }
};